import { version } from '@Config/config'

export const loadVersion = () => {
  const currentVersion = localStorage.getItem('version')
  if (currentVersion !== version) {
      localStorage.clear()
      localStorage.setItem('version', version)
  }
}
